import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { applyMiddleware, createStore } from 'redux'
import thunk from 'redux-thunk'
import { Provider } from 'react-redux'
import { IndexRoute, Route, Router } from 'react-router'
import { keyBy } from 'lodash'

import { withStaticProps } from '../../lib/decorators'
import { getHistory } from '../../lib/history'
import * as blUrls from '../../lib/urls'

import EmailCapture from './email-capture'
import QuestionList from './question-list'
import ChecklistWrapper from '../components/checklist-wrapper'

import { SET_CHECKLIST, SET_QUESTIONS } from '../actions'
import checklistReducer from '../reducers'

const middlewares = [thunk]

if (process.env.NODE_ENV == 'development') {
  // middlewares.push(createLogger())
}
const createStoreWithMiddleware = applyMiddleware(...middlewares)(createStore)

class ChecklistApp extends Component {
  constructor(props) {
    super(props)
    this.store = createStoreWithMiddleware(checklistReducer)
    this.store.dispatch({ type: SET_CHECKLIST, checklist: props.checklist })
    this.store.dispatch({
      type: SET_QUESTIONS,
      questions: keyBy(props.questions, 'id'),
    })
  }

  render() {
    const DecoratedQuestionList = withStaticProps('QuestionList', {
      currentUser: this.props.currentUser,
    })(QuestionList)
    const history = getHistory({ path: this.props.path, useRouter: true })

    return (
      <Provider store={this.store}>
        <Router history={history}>
          <Route
            path={blUrls.checklistQuizPath}
            component={(routerProps) => (
              <ChecklistWrapper isEuIp={this.props.isEuIp} {...routerProps} />
            )}
            onChange={() => window.scrollTo(0, 0)}
          >
            <IndexRoute component={DecoratedQuestionList} />
            <Route
              path={`${blUrls.checklistQuizPath}/q/:questionId`}
              component={DecoratedQuestionList}
            />
            <Route
              path={`${blUrls.checklistQuizPath}/email`}
              component={EmailCapture}
            />
          </Route>
        </Router>
      </Provider>
    )
  }
}

ChecklistApp.propTypes = {
  isEuIp: PropTypes.bool.isRequired,
}

export default ChecklistApp
